import apiClient from '../api/api';

// TypeScript interfaces
export interface SocialLoginProvider {
  provider_name: string;
  is_active: boolean;
  logo_url: string;
  redirect_url: string;
}

export interface LoginRequestData {
  _id: string;
  createdAt: string;
  updatedAt: string;
  classical_provider: boolean;
  social_provider: SocialLoginProvider[];
}

export interface LoginRequestResponse {
  success: boolean;
  code: number;
  data: LoginRequestData;
}

class LoginRequestLogsService {
  private readonly BASE_PATH = '/dms-v2-srv/login-request-logs-srv';

  // POST: Create login request log
  async createLoginRequestLog(): Promise<LoginRequestResponse> {
    try {
      const response = await apiClient.post(this.BASE_PATH, {});
      return response.data;
    } catch (error) {
      console.error('Error creating login request log:', error);
      throw error;
    }
  }
}

export const loginRequestLogsService = new LoginRequestLogsService();
export default loginRequestLogsService;